import {H1, LabelRegular} from '@hm/fundamental'
import {useTranslation} from 'react-i18next'

import {EmptyComponentIllustration} from '../StaticPartDetail/StaticPartDetailCard/StaticPartDetailCardBody/EmptyComponent/EmptyComponentIllustration'

export const StaticPartReplacementEditNotFound = () => {
  const {t} = useTranslation()
  return (
    <div>
      <div className="flex justify-center items-center h-full w-full min-h-[600px]">
        <div className="flex flex-col gap-8 items-center">
          <EmptyComponentIllustration />
          <H1>{t('staticParts.emptyComponent.title')}</H1>
          <div className="flex flex-col gap-4 items-center text-foreground_faded">
            <LabelRegular color="secondary">
              {t('staticParts.emptyComponent.subtitle1')}
            </LabelRegular>
            <LabelRegular color="secondary">
              {t('staticParts.emptyComponent.subtitle2')}
            </LabelRegular>
          </div>
        </div>
      </div>
    </div>
  )
}
